import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/kintai/list',
    name: 'KintaiList',
    component: () => import('@/components/kintai/page/KintaiListPage.vue')
  },
  {
    path: '/kintai/input',
    name: 'KintaiInput',
    component: () => import('@/components/kintai/page/KintaiInputPage.vue')
  },
  {
    path: '/timecard',
    name: 'TimeCard',
    component: () => import('@/components/kintai/page/TimeCardPage.vue')
  },
  {
    path: '/settei/list',
    name: 'SetteiList',
    component: () => import('@/components/settei/page/SetteiListPage.vue')
  },
  {
    path: '/settei/user',
    name: 'UserSetteiPage',
    component: () => import('@/components/settei/page/UserSetteiPage.vue')
  },
  {
    path: '/settei/project',
    name: 'ProjectSettei',
    component: () => import('@/components/project/page/ProjectSetteiPage.vue')
  },
  {
    path: '/settei/password',
    name: 'PasswordChange',
    component: () => import('@/components/account/page/PasswordChangePage.vue')
  },
  {
    path: '/settei/shounin/route',
    component: () => import('@/components/settei/page/ShouninRoutePage.vue')
  },
  {
    path: '/pattern/kintai/',
    name: 'KintaiPattern',
    component: () => import('@/components/pattern/page/KintaiPatternPage.vue')
  },
  {
    path: '/pattern/kintai/list',
    component: () => import('@/components/pattern/page/KintaiPatternListPage.vue')
  },
  {
    path: '/pattern/kintai/:patternId',
    name: 'KintaiPattern',
    component: () => import('@/components/pattern/page/KintaiPatternPage.vue')
  },
  {
    path: '/application/list',
    component: () => import('@/components/application/page/AppMenuListPage.vue')
  },
  {
    path: '/koutsuhi/list',
    component: () => import('@/components/koutsuhi/page/KoutsuhiListPage.vue')
  },
  {
    path: '/koutsuhi/input',
    component: () => import('@/components/koutsuhi/page/KoutsuhiInputPage.vue')
  },
  {
    path: '/koutsuhi/edit/:kintaiId',
    component: () => import('@/components/koutsuhi/page/KoutsuhiInputPage.vue')
  },
  {
    // 年月指定した提出情報作成画面
    path: '/teishutsu/:year/:month',
    component: () => import('@/components/shounin/page/TeishutsuInputPage.vue')
  },
  {
    // ログインユーザの提出情報
    path: '/teishutsu/last',
    component: () => import('@/components/shounin/page/LastTeishutsuPage.vue')
  },
  {
    // 他ユーザの提出情報
    path: '/teishutsu/:year/:month/:teishutsushaId',
    component: () => import('@/components/shounin/page/ShouninKintaiListPage.vue')
  },
  {
    // チーム内の提出状況確認画面
    path: '/teishutsu/member/status/:year/:month',
    component: () => import('@/components/shounin/page/TeishutsuStatusPage.vue')
  },
  {
    path: '/shounin/:year/:month',
    component: () => import('@/components/shounin/page/ShouninPage.vue')
  },
  {
    path: '/shounin/:year/:month/:teishutsushaId',
    component: () => import('@/components/shounin/page/ShouninPage.vue')
  },
  {
    path: '/shounin/tasks',
    component: () => import('@/components/shounin/page/ShouninList.vue')
  },
  {
    path: '/shounin/tasks/:fast',
    component: () => import('@/components/shounin/page/ShouninList.vue')
  },
  {
    path: '/pattern/koutsuhi/',
    component: () => import('@/components/pattern/page/KoutsuhiPatternInputPage.vue')
  },
  {
    path: '/pattern/koutsuhi/list',
    component: () => import('@/components/pattern/page/KoutsuhiPatternListPage.vue')
  },
  {
    path: '/pattern/koutsuhi/:patternId',
    component: () => import('@/components/pattern/page/KoutsuhiPatternInputPage.vue')
  },
  {
    path: '/excel',
    component: () => import('@/components/excel/page/ExportImport.vue')
  },
  {
    path: '/toiawase',
    component: () => import('@/components/help/page/ToiawasePage.vue')
  },
  {
    path: '/user/list',
    component: () => import('@/components/user/page/UserListPage.vue')
  },
  {
    path: '/user/create',
    component: () => import('@/components/user/page/UserInputPage.vue')
  },
  {
    path: '/user/input/:userId',
    component: () => import('@/components/user/page/UserInputPage.vue')
  },
  {
    path: '/*',
    component: () => import('@/components/application/page/CommingSoon.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
